import script from "./header-user.vue?vue&type=script&setup=true&lang=js"
export * from "./header-user.vue?vue&type=script&setup=true&lang=js"

import "./header-user.vue?vue&type=style&index=0&id=5df47e67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df47e67"]])

export default __exports__